import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { connect } from 'react-redux'

const mapStateToProps = state => {
	return {
	  curriculum: state.assessment?.curriculum || []
  }
}
const TextCurriculum = ({ label, className, style, curriculum }) => {

  if (curriculum && curriculum.length > 0) {
  return (
      <Tooltip arrow key={label}
        title={
          <React.Fragment>
            { curriculum.map((curriculum) => (
                <Typography variant='inherit' component='p' key={`curriculum-reference-${curriculum._id}`}>{curriculum.name}</Typography>
              ))
            }
          </React.Fragment>
        }	
      >
        <Typography variant='inherit' component='p' className={className} style={style}>{label} ^</Typography>
      </Tooltip>
    )
  } else {
    return (<Typography variant='inherit' component='p' className={className} style={style}>{label} ^</Typography>)
  }
}

export default connect(
	mapStateToProps
)(TextCurriculum)